import React from 'react'
import styles from './Menu.module.css'
import { Link } from 'react-router-dom';
import Navbar from './Navbar'
import Carousel from './Carousel';
import Shared from '../services/Shared';

const ITEMS = [
        {
            name: 'Catalog',
            path: Shared.path.catalog,
            src: `${Shared.assets}/graduate_a.png`
        },
        {
            name: 'Register',
            path: Shared.path.register,
            src: `${Shared.assets}/graduate_b.png`
        },
        {
            name: 'Schedule',
            path: Shared.path.schedule,
            src: `${Shared.assets}/graduate_c.png`
        },
        {
            name: 'Campus Map',
            path: Shared.path.map,
            src: `${Shared.assets}/graduate_d.png`
        },
        {
            name: 'Faculty',
            path: Shared.path.faculty,
            src: `${Shared.assets}/graduate_e.png`
        },
        {
            name: 'Log out',
            path: Shared.path.login,
            src: `${Shared.assets}/graduate_f.png`
        }
    ];

export default function Menu() {

    function onClick(item) {

        if(item.name === "Log out") {
            Shared.removeSession();
        }
    }

    return (
        <>
            <Navbar></Navbar>
            <div className={styles.contain}>
                <div className={styles.slogan}><img className={styles.sloganImg} alt='Home of the Tail Waggers!' src={Shared.assets + "/tail_waggers_portrait.png"}/></div>
                <div className={styles.photoTitle}>Photos from last Friday's football game</div>
                <Carousel></Carousel>
                <div className={styles.menuDiv}>
                    {ITEMS.map(i => {
                        return (
                            <Link to={i.path} key={i.name} className={styles.cardDiv} onClick={() => onClick(i)}>
                                <div>
                                    <img className={styles.img} alt={i.name} src={i.src} />
                                </div>
                                <div className={styles.txt}>{i.name}</div>
                            </Link>)
                    })}
                </div>
            </div>
        </>
    )
}
